// Swiss portfolio page — monolithic iframe block
// Swiss/Bauhaus identity studio with 4 brand themes (t1–t4).

export type SwissPortfolioBrand = 't1' | 't2' | 't3' | 't4'
export interface SwissPortfolioPageData { brand?: SwissPortfolioBrand }
export const DEFAULT_SWISS_PORTFOLIO_DATA: SwissPortfolioPageData = { brand: 't1' }

// ── CSS ───────────────────────────────────────────────────────────────────────
const SWISS_PORTFOLIO_CSS = `
/* ============ БАЗА / ТЕМЫ ============ */
:root{
  --bg:#F2F1EC; --ink:#121210; --accent:#E30613; --on-accent:#FFFFFF;
  --line:rgba(18,18,16,.16); --muted:#6E6D66; --card:#E9E7DF;
  --font-d:'Archivo',system-ui,sans-serif; --font-m:'IBM Plex Mono',monospace;
  --head-h:64px;
}
html[data-theme="t2"]{ --bg:#0E0E0D; --ink:#F2F2EF; --accent:#D8FF3A; --on-accent:#0E0E0D; --line:rgba(242,242,239,.16); --muted:#9A9A93; --card:#161614; }
html[data-theme="t3"]{ --bg:#F6F7FB; --ink:#0B0D14; --accent:#2438E8; --on-accent:#FFFFFF; --line:rgba(11,13,20,.15); --muted:#676B78; --card:#ECEEF6; }
html[data-theme="t4"]{ --bg:#F1E8DA; --ink:#1B1510; --accent:#FF4D00; --on-accent:#1B1510; --line:rgba(27,21,16,.18); --muted:#77705F; --card:#E9DFCE; }

*{margin:0;padding:0;box-sizing:border-box}
html{scroll-behavior:smooth}
body{
  background:var(--bg); color:var(--ink);
  font-family:var(--font-d); font-size:16px; line-height:1.5;
  transition:background-color .5s ease,color .5s ease;
  -webkit-font-smoothing:antialiased; overflow-x:hidden;
}
::selection{background:var(--accent);color:var(--on-accent)}
a{color:inherit;text-decoration:none}
button{font-family:inherit;color:inherit;background:none;border:none;cursor:pointer}
img{display:block;max-width:100%}
:focus-visible{outline:2px solid var(--accent);outline-offset:3px}
::-webkit-scrollbar{width:10px}
::-webkit-scrollbar-track{background:var(--bg)}
::-webkit-scrollbar-thumb{background:var(--muted);border:3px solid var(--bg)}

.wrap{max-width:1520px;margin:0 auto;padding:0 clamp(16px,4vw,48px)}
.mono{font-family:var(--font-m);font-size:11px;letter-spacing:.08em;text-transform:uppercase}
.muted{color:var(--muted)}

/* шум */
.noise{position:fixed;inset:0;z-index:60;pointer-events:none;opacity:.055;
  background-image:url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='240' height='240'%3E%3Cfilter id='n'%3E%3CfeTurbulence type='fractalNoise' baseFrequency='0.9' numOctaves='2'/%3E%3C/filter%3E%3Crect width='100%25' height='100%25' filter='url(%23n)'/%3E%3C/svg%3E");}

/* ============ ШАПКА ============ */
header{position:fixed;top:0;left:0;right:0;z-index:50;height:var(--head-h);
  background:color-mix(in srgb,var(--bg) 88%,transparent);
  backdrop-filter:blur(8px);border-bottom:1px solid var(--line);transition:background-color .5s ease}
.head-in{height:var(--head-h);display:flex;align-items:center;gap:16px}
.mark{display:flex;align-items:center;justify-content:center;width:40px;height:40px;
  font-weight:900;font-size:13px;letter-spacing:-.02em;flex:none;
  background:var(--ink);color:var(--bg);transition:all .4s ease}
html[data-theme="t2"] .mark{background:transparent;color:var(--accent);box-shadow:inset 0 0 0 2px var(--accent)}
html[data-theme="t3"] .mark{background:var(--accent);color:var(--on-accent);border-radius:50%}
html[data-theme="t4"] .mark{background:var(--accent);color:var(--on-accent);transform:rotate(-6deg)}
.brand-name{font-weight:900;font-size:18px;letter-spacing:-.02em}
.brand-name sup{font-size:9px}
nav.main{display:flex;gap:22px;margin-left:28px}
nav.main a{font-family:var(--font-m);font-size:11px;letter-spacing:.1em;text-transform:uppercase;position:relative;padding:4px 0}
nav.main a::after{content:"";position:absolute;left:0;bottom:0;height:2px;width:0;background:var(--accent);transition:width .3s ease}
nav.main a:hover::after{width:100%}
.head-right{margin-left:auto;display:flex;align-items:center;gap:14px}
.clock{font-family:var(--font-m);font-size:11px;letter-spacing:.08em;color:var(--muted)}
.switch{display:flex;border:1px solid var(--line)}
.switch button{font-family:var(--font-m);font-size:11px;letter-spacing:.06em;padding:8px 12px;color:var(--muted);transition:all .25s ease;border-right:1px solid var(--line)}
.switch button:last-child{border-right:none}
.switch button i{font-style:normal;margin-right:6px}
.switch button span{display:inline-block}
.switch button:hover{color:var(--ink)}
.switch button.active{background:var(--accent);color:var(--on-accent)}
.burger{display:none;width:40px;height:40px;position:relative}
.burger span{position:absolute;left:9px;right:9px;height:2px;background:var(--ink);transition:all .3s ease}
.burger span:nth-child(1){top:14px}.burger span:nth-child(2){top:24px}
body.nav-open .burger span:nth-child(1){top:19px;transform:rotate(45deg)}
body.nav-open .burger span:nth-child(2){top:19px;transform:rotate(-45deg)}

/* оверлей-меню */
.ov{position:fixed;inset:0;z-index:45;background:var(--ink);color:var(--bg);
  transform:translateY(-102%);transition:transform .55s cubic-bezier(.7,0,.2,1);
  display:flex;flex-direction:column;justify-content:center;padding:96px clamp(20px,7vw,90px) 40px}
body.nav-open .ov{transform:translateY(0)}
.ov a{font-weight:900;font-size:clamp(34px,8vw,72px);letter-spacing:-.03em;line-height:1.14;
  opacity:0;transform:translateY(30px);transition:opacity .5s ease,transform .5s ease}
body.nav-open .ov a{opacity:1;transform:none}
.ov a:hover{color:var(--accent)}
.ov a:nth-child(1){transition-delay:.15s}.ov a:nth-child(2){transition-delay:.22s}
.ov a:nth-child(3){transition-delay:.29s}.ov a:nth-child(4){transition-delay:.36s}
.ov-foot{margin-top:auto;display:flex;justify-content:space-between;gap:16px;color:var(--muted)}

/* ============ ХИРО ============ */
.hero{padding-top:calc(var(--head-h) + clamp(28px,5vh,64px));position:relative}
.hero-top{display:flex;justify-content:space-between;gap:16px;border-bottom:1px solid var(--line);padding-bottom:14px}
.hero-grid{display:grid;grid-template-columns:repeat(12,1fr);gap:0;border-bottom:1px solid var(--line)}
.hero-left{grid-column:1/9;padding:clamp(20px,3vw,44px) clamp(0px,2vw,32px) clamp(28px,3.4vw,52px) 0;position:relative}
.hero-title{font-weight:900;font-size:clamp(88px,17.5vw,268px);line-height:.82;letter-spacing:-.045em;display:flex;align-items:flex-start;gap:.02em}
.hero-title .reg{font-size:clamp(14px,1.6vw,24px);font-weight:500;margin-top:.35em}
.tagline{margin-top:clamp(20px,3vw,40px);font-weight:700;font-size:clamp(20px,2.6vw,38px);line-height:1.12;letter-spacing:-.02em;max-width:16em}
.lm{display:block;overflow:hidden}
.lm>span{display:block;transform:translateY(115%);transition:transform .9s cubic-bezier(.2,.7,.2,1)}
.play .lm:nth-child(1)>span{transition-delay:.05s}
.play .lm:nth-child(2)>span{transition-delay:.15s}
.play .lm:nth-child(3)>span{transition-delay:.25s}
.play .lm>span{transform:translateY(0)}
.lede{margin-top:22px;max-width:46ch;color:var(--muted);font-size:15px}
.hero-right{grid-column:9/13;border-left:1px solid var(--line);padding:clamp(20px,2.4vw,36px);display:flex;flex-direction:column;gap:14px}
.frame{border:1px solid var(--line);background:var(--card);padding:10px;position:relative;overflow:hidden}
.frame img{width:100%;aspect-ratio:1/1;object-fit:cover;transition:opacity .45s ease,transform 6s ease;filter:contrast(1.02)}
.frame:hover img{transform:scale(1.04)}
.frame .corner{position:absolute;top:10px;left:10px;background:var(--accent);color:var(--on-accent);font-family:var(--font-m);font-size:10px;letter-spacing:.1em;padding:4px 8px}
.cap{display:flex;justify-content:space-between;gap:10px;font-family:var(--font-m);font-size:11px;letter-spacing:.06em;text-transform:uppercase}
.cap b{color:var(--accent);font-weight:500}
.hero-index{margin-top:auto;display:flex;align-items:baseline;justify-content:space-between;border-top:1px solid var(--line);padding-top:12px}
.hero-index .big{font-weight:900;font-size:clamp(28px,3vw,44px);letter-spacing:-.03em}
.hero-index .big em{font-style:normal;color:var(--accent)}
/* статистика */
.stats{display:grid;grid-template-columns:repeat(4,1fr);border-bottom:1px solid var(--line)}
.stat{padding:clamp(16px,2vw,28px);border-right:1px solid var(--line)}
.stat:last-child{border-right:none}
.stat .num{font-weight:900;font-size:clamp(30px,3.6vw,56px);letter-spacing:-.03em;line-height:1}
.stat .num i{font-style:normal;color:var(--accent)}
.stat .lbl{margin-top:6px}

/* ============ БЕГУЩАЯ СТРОКА ============ */
.marquee{background:var(--accent);color:var(--on-accent);overflow:hidden;border-bottom:1px solid var(--line);transition:background-color .5s ease}
.mq-track{display:flex;width:max-content;animation:mq 26s linear infinite}
.mq-track span{font-family:var(--font-m);font-size:12px;letter-spacing:.14em;text-transform:uppercase;padding:12px 0;white-space:nowrap}
@keyframes mq{to{transform:translateX(-50%)}}
.marquee:hover .mq-track{animation-play-state:paused}

/* ============ СЕКЦИИ ============ */
section{position:relative}
.sec-head{display:flex;align-items:baseline;justify-content:space-between;gap:16px;padding:clamp(20px,2.6vw,36px) 0;border-bottom:1px solid var(--line)}
.sec-head h2{font-weight:900;font-size:clamp(30px,5vw,72px);letter-spacing:-.03em;line-height:1}
.sec-head .idx{font-family:var(--font-m);font-size:12px;color:var(--accent)}

/* манифест */
.manifesto{display:grid;grid-template-columns:4fr 8fr;border-bottom:1px solid var(--line)}
.mani-aside{border-right:1px solid var(--line);padding:clamp(20px,2.4vw,40px)}
.sticky{position:sticky;top:calc(var(--head-h) + 20px)}
.mani-aside .k{font-family:var(--font-m);font-size:11px;letter-spacing:.12em;text-transform:uppercase;color:var(--accent)}
.mani-aside .t{margin-top:10px;font-weight:900;font-size:clamp(22px,2.2vw,32px);letter-spacing:-.02em}
.mani-body{padding:clamp(24px,3vw,52px)}
.mani-text{font-weight:700;font-size:clamp(21px,2.7vw,40px);line-height:1.22;letter-spacing:-.02em;max-width:24em}
.mani-text em{font-style:normal;color:var(--accent)}
.mani-note{margin-top:26px;max-width:58ch;color:var(--muted);font-size:15px}

/* работы */
.works{border-bottom:1px solid var(--line)}
.works .watermark{position:absolute;right:-2%;top:8%;z-index:0;font-weight:900;font-size:clamp(120px,24vw,400px);line-height:1;color:transparent;-webkit-text-stroke:1px var(--line);pointer-events:none;user-select:none}
.w-cards{display:grid;grid-template-columns:1fr 1fr;gap:1px;background:var(--line);border-bottom:1px solid var(--line);position:relative;z-index:1}
.w-card{background:var(--bg);padding:clamp(16px,2vw,28px);transition:background-color .35s ease}
.w-card:hover{background:var(--card)}
.w-prev{aspect-ratio:16/10;border:1px solid var(--line);overflow:hidden;position:relative;background:var(--bg)}
.w-prev::after{content:"";position:absolute;inset:0;background:var(--accent);mix-blend-mode:multiply;opacity:0;transition:opacity .35s ease}
html[data-theme="t2"] .w-prev::after{mix-blend-mode:normal;opacity:0}
.w-card:hover .w-prev::after, .w-row:hover .w-prev::after{opacity:.14}
.w-meta{display:flex;justify-content:space-between;align-items:baseline;gap:10px;margin-top:14px}
.w-title{font-weight:900;font-size:clamp(22px,2.4vw,36px);letter-spacing:-.02em}
.w-year{font-family:var(--font-m);font-size:12px;color:var(--muted)}
.w-tags{margin-top:6px;color:var(--muted)}
.w-arrow{display:inline-block;transition:transform .3s ease;color:var(--accent)}
.w-card:hover .w-arrow,.w-row:hover .w-arrow{transform:translate(6px,-6px)}
.w-rows{position:relative;z-index:1}
.w-row{display:grid;grid-template-columns:70px 1fr 150px auto 60px 40px;align-items:center;gap:16px;padding:clamp(16px,2vw,26px) 4px;border-bottom:1px solid var(--line);transition:background-color .3s ease,color .3s ease;cursor:pointer}
.w-row:last-child{border-bottom:none}
.w-row .n{font-family:var(--font-m);font-size:12px;color:var(--muted)}
.w-row .w-prev{aspect-ratio:16/9;width:150px}
.w-row:hover{background:var(--ink);color:var(--bg)}
.w-row:hover .n,.w-row:hover .w-year,.w-row:hover .w-tags{color:var(--bg)}
.w-row:hover .w-arrow{color:var(--accent)}

/* паттерны */
.pat-a{background:repeating-linear-gradient(45deg,var(--accent) 0 10px,transparent 10px 26px)}
.pat-b{background:radial-gradient(var(--ink) 1.6px,transparent 1.7px);background-size:14px 14px}
.pat-c{background:conic-gradient(var(--ink) 25%,transparent 0 50%,var(--ink) 0 75%,transparent 0);background-size:36px 36px}
.pat-d{background:repeating-radial-gradient(circle at 30% 60%,var(--accent) 0 3px,transparent 3px 22px)}
.pat-e{background:repeating-linear-gradient(90deg,var(--ink) 0 4px,transparent 4px 24px)}
.pat-f{background:linear-gradient(135deg,var(--accent) 0 50%,transparent 50%),repeating-linear-gradient(0deg,var(--ink) 0 2px,transparent 2px 18px)}

/* услуги */
.services{display:grid;grid-template-columns:4fr 8fr;border-bottom:1px solid var(--line)}
.serv-aside{border-right:1px solid var(--line);padding:clamp(20px,2.4vw,40px)}
.serv-list{list-style:none}
.serv-list li{display:grid;grid-template-columns:64px 1fr;gap:18px;padding:clamp(18px,2.2vw,30px) clamp(16px,2.4vw,40px);border-bottom:1px solid var(--line);transition:padding-left .3s ease,background-color .3s ease}
.serv-list li:last-child{border-bottom:none}
.serv-list li:hover{background:var(--card);padding-left:calc(clamp(16px,2.4vw,40px) + 12px)}
.serv-list .sn{font-family:var(--font-m);font-size:12px;color:var(--accent);padding-top:6px}
.serv-list h3{font-weight:900;font-size:clamp(20px,2.2vw,32px);letter-spacing:-.02em}
.serv-list p{margin-top:6px;color:var(--muted);max-width:52ch;font-size:14px}

/* клиенты / награды */
.duo{display:grid;grid-template-columns:1fr 1fr;border-bottom:1px solid var(--line)}
.duo>div{padding:clamp(20px,2.4vw,40px)}
.duo>div:first-child{border-right:1px solid var(--line)}
.duo h4{font-family:var(--font-m);font-size:11px;letter-spacing:.12em;text-transform:uppercase;color:var(--accent);margin-bottom:18px}
.clients{display:grid;grid-template-columns:repeat(3,1fr);border-top:1px solid var(--line);border-left:1px solid var(--line)}
.clients span{border-right:1px solid var(--line);border-bottom:1px solid var(--line);padding:14px 10px;text-align:center;font-family:var(--font-m);font-size:11px;letter-spacing:.1em;transition:all .25s ease;cursor:default}
.clients span:hover{background:var(--accent);color:var(--on-accent)}
.awards{list-style:none}
.awards li{display:flex;justify-content:space-between;gap:14px;padding:12px 0;border-bottom:1px solid var(--line);font-size:14px}
.awards li:last-child{border-bottom:none}
.awards .yr{font-family:var(--font-m);font-size:11px;color:var(--muted)}
.awards li:hover .aw-name{color:var(--accent)}

/* контакт */
.contact{padding:clamp(48px,8vh,110px) 0;border-bottom:1px solid var(--line);overflow:hidden}
.contact .kick{font-family:var(--font-m);font-size:11px;letter-spacing:.14em;text-transform:uppercase;color:var(--accent)}
.contact h2{margin-top:16px;font-weight:900;font-size:clamp(44px,9.5vw,150px);letter-spacing:-.04em;line-height:.95}
.contact h2 .dot{color:var(--accent)}
.mail-row{margin-top:clamp(24px,3vw,44px);display:flex;flex-wrap:wrap;gap:14px;align-items:center}
.mail-btn{font-family:var(--font-m);font-size:13px;letter-spacing:.06em;border:1px solid var(--ink);padding:14px 22px;position:relative;overflow:hidden;transition:color .3s ease}
.mail-btn::before{content:"";position:absolute;inset:0;background:var(--accent);transform:translateY(101%);transition:transform .35s cubic-bezier(.2,.7,.2,1);z-index:-1}
.mail-btn:hover{color:var(--on-accent);border-color:var(--accent)}
.mail-btn:hover::before{transform:translateY(0)}
.socials{display:flex;gap:18px}
.socials a{font-family:var(--font-m);font-size:11px;letter-spacing:.1em;text-transform:uppercase;border-bottom:1px solid var(--line);padding-bottom:2px;transition:all .25s}
.socials a:hover{color:var(--accent);border-color:var(--accent)}

/* футер */
footer{padding:26px 0 34px}
.foot{display:grid;grid-template-columns:2fr 1fr 1fr 1.4fr;gap:24px}
.foot h5{font-family:var(--font-m);font-size:10px;letter-spacing:.12em;text-transform:uppercase;color:var(--muted);margin-bottom:10px}
.foot a{display:block;font-size:13px;padding:3px 0}
.foot a:hover{color:var(--accent)}
.foot .f-brand{font-weight:900;font-size:20px;letter-spacing:-.02em}
.foot .small{font-size:12px;color:var(--muted)}
.top-btn{margin-top:12px;font-family:var(--font-m);font-size:11px;letter-spacing:.1em;border:1px solid var(--line);padding:8px 14px;transition:all .3s}
.top-btn:hover{background:var(--ink);color:var(--bg)}

/* reveal */
.rv{opacity:0;transform:translateY(26px);transition:opacity .8s ease,transform .8s cubic-bezier(.2,.7,.2,1)}
.rv.in{opacity:1;transform:none}

/* ============ АДАПТИВ ============ */
@media(max-width:1080px){
  nav.main{display:none}
  .burger{display:block}
  .switch button span{display:none}
  .hero-left{grid-column:1/13;padding-right:0}
  .hero-right{grid-column:1/13;border-left:none;border-top:1px solid var(--line)}
  .manifesto,.services{grid-template-columns:1fr}
  .mani-aside,.serv-aside{border-right:none;border-bottom:1px solid var(--line)}
  .sticky{position:static}
  .duo{grid-template-columns:1fr}
  .duo>div:first-child{border-right:none;border-bottom:1px solid var(--line)}
  .w-row{grid-template-columns:44px 1fr 40px;grid-template-areas:"n t a" "n p a" "n y a"}
  .w-row .n{grid-area:n}.w-row .w-title{grid-area:t}.w-row .w-arrow{grid-area:a}
  .w-row .w-prev{grid-area:p;width:100%;max-width:260px;margin-top:8px}
  .w-row .w-tags{grid-area:y}
  .w-row .w-year{display:none}
  .foot{grid-template-columns:1fr 1fr}
}
@media(max-width:640px){
  .clock{display:none}
  .stats{grid-template-columns:1fr 1fr}
  .stat:nth-child(2){border-right:none}
  .stat:nth-child(1),.stat:nth-child(2){border-bottom:1px solid var(--line)}
  .w-cards{grid-template-columns:1fr}
  .clients{grid-template-columns:repeat(2,1fr)}
  .foot{grid-template-columns:1fr}
  .hero-title{font-size:clamp(76px,24vw,140px)}
}

/* reduced motion */
@media (prefers-reduced-motion: reduce){
  html{scroll-behavior:auto}
  *,*::before,*::after{animation:none!important;transition:none!important}
  .rv{opacity:1;transform:none}
  .lm>span{transform:none}
}
`

// ── HTML body ─────────────────────────────────────────────────────────────────
const SWISS_PORTFOLIO_HTML_BODY = `
<div class="noise" aria-hidden="true"></div>

<!-- ШАПКА -->
<header>
  <div class="wrap head-in">
    <a href="#top" class="mark" aria-label="BST — на главную">BST</a>
    <span class="brand-name">BST<sup>®</sup></span>
    <nav class="main" aria-label="Основная навигация">
      <a href="#works">Работы</a>
      <a href="#studio">Студия</a>
      <a href="#services">Услуги</a>
      <a href="#contact">Контакт</a>
    </nav>
    <div class="head-right">
      <span class="clock" id="clock">00:00:00</span>
      <div class="switch" role="tablist" aria-label="Бренд-варианты">
        <button data-set-theme="t1" class="active" role="tab" aria-selected="true"><i>01</i><span>Raster</span></button>
        <button data-set-theme="t2" role="tab" aria-selected="false"><i>02</i><span>Noir</span></button>
        <button data-set-theme="t3" role="tab" aria-selected="false"><i>03</i><span>Blau</span></button>
        <button data-set-theme="t4" role="tab" aria-selected="false"><i>04</i><span>Solar</span></button>
      </div>
      <button class="burger" id="burger" aria-label="Меню"><span></span><span></span></button>
    </div>
  </div>
</header>

<!-- ОВЕРЛЕЙ МЕНЮ -->
<div class="ov" id="ov">
  <a href="#works">Работы</a>
  <a href="#studio">Студия</a>
  <a href="#services">Услуги</a>
  <a href="#contact">Контакт</a>
  <div class="ov-foot mono"><span id="ovTheme">Вариант 01 — Raster</span><span>BST® / 2025</span></div>
</div>

<main id="top">
  <!-- ХИРО -->
  <section class="hero wrap">
    <div class="hero-top mono muted">
      <span id="variantLabel">Вариант 01 — Raster</span>
      <span>Портфолио студии · 2013—2025</span>
      <span>47.55° N, 7.58° E</span>
    </div>
    <div class="hero-grid">
      <div class="hero-left">
        <h1 class="hero-title"><span id="bstTitle">BST</span><span class="reg">®</span></h1>
        <p class="tagline" id="tagline">
          <span class="lm"><span>Дисциплина сетки.</span></span>
          <span class="lm"><span>Ясность знака.</span></span>
          <span class="lm"><span>Точность формы.</span></span>
        </p>
        <p class="lede" id="lede">Классическая швейцарская школа: модульная сетка, гротеск и один красный акцент. Айдентика для институций культуры.</p>
      </div>
      <aside class="hero-right">
        <div class="frame">
          <span class="corner" id="cornerLabel">Кейс 01</span>
          <img id="featuredImg" src="https://image.qwenlm.ai/public_source/3959de43-1a75-4d12-b8da-faee2c19b23d/1eeec8c09-fb8a-494e-8d79-5b8a703011e0.png" alt="Плакат бренд-варианта BST">
        </div>
        <div class="cap"><b id="featuredTitle">Музей «Пласт»</b><span id="featuredMeta">Айдентика · Навигация · Плакат — 2025</span></div>
        <div class="hero-index">
          <span class="mono muted">Бренд-вариант</span>
          <span class="big"><em id="idxNow">01</em>/04</span>
        </div>
      </aside>
    </div>
    <div class="stats">
      <div class="stat rv"><div class="num">12<i>+</i></div><div class="lbl mono muted" data-t="stat1L">лет практики</div></div>
      <div class="stat rv"><div class="num">240<i>+</i></div><div class="lbl mono muted" data-t="stat2L">проектов</div></div>
      <div class="stat rv"><div class="num">18</div><div class="lbl mono muted" data-t="stat3L">международных наград</div></div>
      <div class="stat rv"><div class="num">04</div><div class="lbl mono muted" data-t="stat4L">бренд-варианта системы</div></div>
    </div>
  </section>

  <!-- БЕГУЩАЯ СТРОКА -->
  <div class="marquee" aria-hidden="true">
    <div class="mq-track">
      <span id="mqA">СЕТКА — ОСНОВА ВСЕГО ● ГЕЛЬВЕТИКА FOREVER ● МЕНЬШЕ, НО ЛУЧШЕ ●&nbsp;</span>
      <span id="mqB">СЕТКА — ОСНОВА ВСЕГО ● ГЕЛЬВЕТИКА FOREVER ● МЕНЬШЕ, НО ЛУЧШЕ ●&nbsp;</span>
    </div>
  </div>

  <!-- МАНИФЕСТ -->
  <section class="manifesto" id="studio">
    <aside class="mani-aside">
      <div class="sticky">
        <div class="k">01 / Студия</div>
        <div class="t">Форма следует сетке</div>
      </div>
    </aside>
    <div class="mani-body">
      <p class="mani-text rv" data-t="maniText">BST — студия швейцарской школы. Мы строим идентичности как системы: <em>модульная сетка</em>, нейтральный гротеск, асимметрия и один акцент. Одна система — четыре характера: от музейной строгости до тёплого рисографа.</p>
      <p class="mani-note rv" data-t="maniNote">Каждый вариант — это не шаблон, а живой бренд-язык: палитра, ритм, плакатная графика и тон коммуникации. Переключите варианты в шапке (клавиши 1–4) и посмотрите, как одна структура обслуживает четыре совершенно разных бренда.</p>
    </div>
  </section>

  <!-- РАБОТЫ -->
  <section class="works" id="works">
    <div class="watermark" aria-hidden="true">BST</div>
    <div class="wrap">
      <div class="sec-head">
        <h2>Избранные работы</h2>
        <span class="idx">(06) / 2023—2025</span>
      </div>
    </div>
    <div class="wrap">
      <div class="w-cards">
        <article class="w-card rv">
          <div class="w-prev pat-a"></div>
          <div class="w-meta"><span class="w-title" data-t="p1Title">Альфа Кант</span><span class="w-year">2025</span></div>
          <div class="w-tags mono muted" data-t="p1Tags">Бренд / Печать / Навигация <span class="w-arrow">↗</span></div>
        </article>
        <article class="w-card rv">
          <div class="w-prev pat-b"></div>
          <div class="w-meta"><span class="w-title" data-t="p2Title">NORDMETALL</span><span class="w-year">2024</span></div>
          <div class="w-tags mono muted" data-t="p2Tags">Ребрендинг / Веб <span class="w-arrow">↗</span></div>
        </article>
      </div>
      <div class="w-rows">
        <div class="w-row rv"><span class="n">03</span><span class="w-title" data-t="p3Title">СФЕРА</span><div class="w-prev pat-c"></div><span class="w-tags mono muted" data-t="p3Tags">Продукт / Система</span><span class="w-year">2025</span><span class="w-arrow">↗</span></div>
        <div class="w-row rv"><span class="n">04</span><span class="w-title" data-t="p4Title">TONHALLE</span><div class="w-prev pat-d"></div><span class="w-tags mono muted" data-t="p4Tags">Плакат / Типографика</span><span class="w-year">2024</span><span class="w-arrow">↗</span></div>
        <div class="w-row rv"><span class="n">05</span><span class="w-title" data-t="p5Title">GRAN</span><div class="w-prev pat-e"></div><span class="w-tags mono muted" data-t="p5Tags">Бренд / Упаковка</span><span class="w-year">2023</span><span class="w-arrow">↗</span></div>
        <div class="w-row rv"><span class="n">06</span><span class="w-title" data-t="p6Title">ПУЛЬС</span><div class="w-prev pat-f"></div><span class="w-tags mono muted" data-t="p6Tags">Диджитал / Редактура</span><span class="w-year">2023</span><span class="w-arrow">↗</span></div>
      </div>
    </div>
  </section>

  <!-- УСЛУГИ -->
  <section class="services" id="services">
    <aside class="serv-aside">
      <div class="sticky">
        <div class="k" style="font-family:var(--font-m);font-size:11px;letter-spacing:.12em;text-transform:uppercase;color:var(--accent)">02 / Услуги</div>
        <div class="t" style="margin-top:10px;font-weight:900;font-size:clamp(22px,2.2vw,32px);letter-spacing:-.02em">Что мы делаем</div>
      </div>
    </aside>
    <ul class="serv-list">
      <li class="rv"><span class="sn">/01</span><div><h3 data-t="svc1Title">Айдентика и бренд-системы</h3><p data-t="svc1Desc">Логотип, фирменный стиль, гайдлайны, носители. Система, которая живёт годами и не разваливается.</p></div></li>
      <li class="rv"><span class="sn">/02</span><div><h3 data-t="svc2Title">Веб и продукт</h3><p data-t="svc2Desc">Сайты, дизайн-системы, интерфейсы, прототипы. Сетка и типографика переносятся в код без потерь.</p></div></li>
      <li class="rv"><span class="sn">/03</span><div><h3 data-t="svc3Title">Типографика и плакат</h3><p data-t="svc3Desc">Шрифтовые композиции, афиши, печатная реклама. Наследие школы Базеля и Цюриха.</p></div></li>
      <li class="rv"><span class="sn">/04</span><div><h3 data-t="svc4Title">Арт-дирекшн</h3><p data-t="svc4Desc">Концепции, съёмки, иллюстрация, моушен. Единый визуальный голос на всех носителях.</p></div></li>
      <li class="rv"><span class="sn">/05</span><div><h3 data-t="svc5Title">Консалтинг и стратегия</h3><p data-t="svc5Desc">Аудит бренда, позиционирование, внедрение системы в команду клиента.</p></div></li>
    </ul>
  </section>

  <!-- КЛИЕНТЫ / НАГРАДЫ -->
  <section class="duo">
    <div>
      <h4>Клиенты (избранное)</h4>
      <div class="clients">
        <span>ПЛАСТ</span><span>NORDMETALL</span><span>СФЕРА</span>
        <span>TONHALLE</span><span>GRAN</span><span>ПУЛЬС</span>
        <span>KRAFTWERK</span><span>ОКТА</span><span>ВОЛНА</span>
        <span>ШТЕЙН</span><span>МИР</span><span>RHEIN</span>
      </div>
    </div>
    <div>
      <h4>Признание</h4>
      <ul class="awards">
        <li><span class="aw-name">Red Dot — Brands &amp; Communication</span><span class="yr">2024</span></li>
        <li><span class="aw-name">ADC — Серебро, айдентика</span><span class="yr">2024</span></li>
        <li><span class="aw-name">Awwwards — Site of the Day ×3</span><span class="yr">2023–25</span></li>
        <li><span class="aw-name">Type Directors Club — Excellence</span><span class="yr">2023</span></li>
      </ul>
    </div>
  </section>

  <!-- КОНТАКТ -->
  <section class="contact wrap" id="contact">
    <div class="kick">03 / Контакт</div>
    <h2 class="rv" data-t="ctaTitle">Обсудим<br>проект<span class="dot">.</span></h2>
    <div class="mail-row rv">
      <button class="mail-btn" id="copyMail">hello@bst.studio — копировать</button>
      <div class="socials">
        <a href="#" rel="noopener">Behance</a>
        <a href="#" rel="noopener">Instagram</a>
        <a href="#" rel="noopener">Telegram</a>
      </div>
    </div>
  </section>
</main>

<!-- ФУТЕР -->
<footer>
  <div class="wrap foot">
    <div>
      <div class="f-brand">BST<sup style="font-size:9px">®</sup></div>
      <p class="small" style="margin-top:8px">Студия айдентики и типографики.<br>Швейцарская школа, четыре характера.</p>
      <button class="top-btn" id="toTop">↑ НАВЕРХ</button>
    </div>
    <div>
      <h5>Навигация</h5>
      <a href="#works">Работы</a><a href="#studio">Студия</a><a href="#services">Услуги</a><a href="#contact">Контакт</a>
    </div>
    <div>
      <h5>Соцсети</h5>
      <a href="#">Behance</a><a href="#">Instagram</a><a href="#">Telegram</a>
    </div>
    <div>
      <h5>Колофон</h5>
      <p class="small">Активный вариант: <span id="themeFoot" style="color:var(--accent)">01 — Raster</span></p>
      <p class="small">Гротеск: Archivo · Моно: IBM Plex Mono</p>
      <p class="small">© 2025 BST®. Сделано по сетке.</p>
    </div>
  </div>
</footer>
`

// ── Engine JS ─────────────────────────────────────────────────────────────────
function swissPortfolioEngineJs(brand: string, mode: 'canvas' | 'preview'): string {
  return `
(function(){
  "use strict";
  var reduced = window.matchMedia("(prefers-reduced-motion: reduce)").matches;

  /* ---------- данные бренд-вариантов ---------- */
  var THEMES = {
    t1:{ idx:"01", name:"Raster",
      tag:["Дисциплина сетки.","Ясность знака.","Точность формы."],
      lede:"Классическая швейцарская школа: модульная сетка, гротеск и один красный акцент. Айдентика для институций культуры.",
      mq:"СЕТКА — ОСНОВА ВСЕГО ● ГЕЛЬВЕТИКА FOREVER ● МЕНЬШЕ, НО ЛУЧШЕ ● ",
      fTitle:"Музей «Пласт»", fMeta:"Айдентика · Навигация · Плакат — 2025",
      img:"https://image.qwenlm.ai/public_source/3959de43-1a75-4d12-b8da-faee2c19b23d/1eeec8c09-fb8a-494e-8d79-5b8a703011e0.png" },
    t2:{ idx:"02", name:"Noir",
      tag:["Тёмная сторона","швейцарской","типографики."],
      lede:"Экспериментальная студия: контраст, негативное пространство и лайм на чёрном. Афиши, моушен, диджитал.",
      mq:"НОЧНОЙ РЕЖИМ ● ЭКСПЕРИМЕНТ ● ТИПОГРАФИКА КАК СИСТЕМА ● КОНТРАСТ 100% ● ",
      fTitle:"Клуб «Штром»", fMeta:"Афиши · Диджитал · Моушен — 2024",
      img:"https://image.qwenlm.ai/public_source/3959de43-1a75-4d12-b8da-faee2c19b23d/11bb96dc5-fe95-4df4-8aaf-7907c1dbb844.png" },
    t3:{ idx:"03", name:"Blau",
      tag:["Системы, которые","масштабируются","без шума."],
      lede:"Инженерный подход к айдентике: дизайн-системы, токены, продукты. Ультрамарин как знак доверия.",
      mq:"СИСТЕМНЫЙ ДИЗАЙН ● ТОЧНОСТЬ ● МАСШТАБ ● ДИЗАЙН-ТОКЕНЫ ● ",
      fTitle:"Финтех «Сфера»", fMeta:"Дизайн-система · Продукт · Веб — 2025",
      img:"https://image.qwenlm.ai/public_source/3959de43-1a75-4d12-b8da-faee2c19b23d/1711269fa-bdfa-4b70-a91b-e2498cd62e0b.png" },
    t4:{ idx:"04", name:"Solar",
      tag:["Тёплая графика","для брендов","стиля жизни."],
      lede:"Рисограф, крафт и оранжевый пигмент. Бренды гостеприимства, упаковки и печатной рекламы.",
      mq:"ТЕПЛО ● ФАКТУРА ● РИТМ ● КРАФТ И ПИГМЕНТ ● ",
      fTitle:"Кофейни GRAN", fMeta:"Бренд · Упаковка · Интерьер — 2023",
      img:"https://image.qwenlm.ai/public_source/3959de43-1a75-4d12-b8da-faee2c19b23d/19aa4b756-d790-4276-b96d-c98399d764d8.png" }
  };

  /* ---------- ссылки на DOM ---------- */
  var root=document.documentElement,
      bstTitle=document.getElementById("bstTitle"),
      tagline=document.getElementById("tagline"),
      lede=document.getElementById("lede"),
      variantLabel=document.getElementById("variantLabel"),
      ovTheme=document.getElementById("ovTheme"),
      themeFoot=document.getElementById("themeFoot"),
      idxNow=document.getElementById("idxNow"),
      cornerLabel=document.getElementById("cornerLabel"),
      featuredImg=document.getElementById("featuredImg"),
      featuredTitle=document.getElementById("featuredTitle"),
      featuredMeta=document.getElementById("featuredMeta"),
      mqA=document.getElementById("mqA"),
      mqB=document.getElementById("mqB"),
      switchBtns=document.querySelectorAll("[data-set-theme]");

  /* предрасчёт: прогрев картинок */
  Object.keys(THEMES).forEach(function(k){ var im=new Image(); im.src=THEMES[k].img; });

  /* ---------- scramble-декодирование BST ---------- */
  var CHARS="BSTKR#01/▮";
  function scrambleTo(el, finalText){
    if(!el || reduced){ if(el) el.textContent=finalText; return; }
    var frame=0, total=26;
    (function tick(){
      var out="";
      for(var i=0;i<finalText.length;i++){
        var reveal = frame/total*finalText.length;
        out += (i<reveal) ? finalText[i] : CHARS[Math.floor(Math.random()*CHARS.length)];
      }
      el.textContent=out;
      if(frame++<total){ requestAnimationFrame(tick); } else { el.textContent=finalText; }
    })();
  }

  /* ---------- применение темы ---------- */
  function applyTheme(id, animate){
    var d=THEMES[id]; if(!d) return;
    root.setAttribute("data-theme", id);
    try{ localStorage.setItem("bst-theme", id); }catch(e){}
    switchBtns.forEach(function(b){
      var on=b.getAttribute("data-set-theme")===id;
      b.classList.toggle("active", on);
      b.setAttribute("aria-selected", on?"true":"false");
    });
    var label="Вариант "+d.idx+" — "+d.name;
    if(variantLabel) variantLabel.textContent=label;
    if(ovTheme) ovTheme.textContent=label;
    if(themeFoot) themeFoot.textContent=d.idx+" — "+d.name;
    if(idxNow) idxNow.textContent=d.idx;
    if(cornerLabel) cornerLabel.textContent="Кейс "+d.idx;
    if(lede) lede.textContent=d.lede;
    if(featuredTitle) featuredTitle.textContent=d.fTitle;
    if(featuredMeta) featuredMeta.textContent=d.fMeta;
    if(mqA) mqA.textContent=d.mq;
    if(mqB) mqB.textContent=d.mq;
    /* тэглайн: пересборка строк + replay line-mask */
    if(tagline){
      tagline.innerHTML = d.tag.map(function(t){ return '<span class="lm"><span>'+t+'</span></span>'; }).join("");
      if(animate!==false){
        tagline.classList.remove("play");
        void tagline.offsetWidth;
        requestAnimationFrame(function(){ tagline.classList.add("play"); });
      }
    }
    if(animate!==false){
      scrambleTo(bstTitle,"BST");
      if(featuredImg){
        featuredImg.style.opacity="0";
        featuredImg.onload=function(){ featuredImg.style.opacity="1"; };
        featuredImg.src=d.img;
      }
    }
  }

  switchBtns.forEach(function(b){
    b.addEventListener("click", function(){ applyTheme(b.getAttribute("data-set-theme")); });
  });
  document.addEventListener("keydown", function(ev){
    var map={"1":"t1","2":"t2","3":"t3","4":"t4"};
    if(map[ev.key] && !ev.metaKey && !ev.ctrlKey){ applyTheme(map[ev.key]); }
    if(ev.key==="Escape"){ document.body.classList.remove("nav-open"); }
  });

  /* сохранённая тема */
  var saved=null; try{ saved=localStorage.getItem("bst-theme"); }catch(e){}
  applyTheme(saved && THEMES[saved] ? saved : "${brand}", false);
  window.addEventListener("load", function(){
    if(tagline) tagline.classList.add("play");
    scrambleTo(bstTitle,"BST");
  });

  /* ---------- часы ---------- */
  var clock=document.getElementById("clock");
  function two(n){ return (n<10?"0":"")+n; }
  function tickClock(){
    var d=new Date();
    if(clock) clock.textContent=two(d.getHours())+":"+two(d.getMinutes())+":"+two(d.getSeconds());
  }
  if(clock){ tickClock(); setInterval(tickClock,1000); }

  /* ---------- reveal on scroll ---------- */
  var io=new IntersectionObserver(function(entries){
    entries.forEach(function(en){
      if(en.isIntersecting){ en.target.classList.add("in"); io.unobserve(en.target); }
    });
  },{threshold:.12});
  document.querySelectorAll(".rv").forEach(function(el,i){
    el.style.transitionDelay=(i%4)*0.08+"s";
    io.observe(el);
  });

  /* ---------- меню ---------- */
  var burger=document.getElementById("burger"), ov=document.getElementById("ov");
  if(burger) burger.addEventListener("click", function(){ document.body.classList.toggle("nav-open"); });
  if(ov) ov.querySelectorAll("a").forEach(function(a){
    a.addEventListener("click", function(){ document.body.classList.remove("nav-open"); });
  });

  /* ---------- копирование почты ---------- */
  var copyBtn=document.getElementById("copyMail");
  if(copyBtn){
    var copyOrig=copyBtn.textContent;
    copyBtn.addEventListener("click", function(){
      function done(){ copyBtn.textContent="Скопировано ✓"; setTimeout(function(){ copyBtn.textContent=copyOrig; },1600); }
      if(navigator.clipboard){ navigator.clipboard.writeText("hello@bst.studio").then(done).catch(done); }
      else{ done(); }
    });
  }

  /* ---------- наверх ---------- */
  var toTop=document.getElementById("toTop");
  if(toTop) toTop.addEventListener("click", function(){
    window.scrollTo({top:0, behavior: reduced ? "auto" : "smooth"});
  });
})();
${mode === 'canvas' ? `(function(){
  document.querySelectorAll('.rv,.reveal,[data-reveal]').forEach(function(el){el.classList.add('in');});
  document.body.classList.add('loaded','js-loaded');
  var tl = document.querySelector('.tagline');
  if(tl) tl.classList.add('play');
  document.addEventListener('click',function(e){var a=e.target.closest('a[href]');if(a)e.preventDefault();},true);
  document.querySelectorAll('form').forEach(function(f){f.addEventListener('submit',function(e){e.preventDefault();});});
})();` : ''}
`
}

// ── Public API ────────────────────────────────────────────────────────────────
export function getSwissPortfolioPageHtml(data: SwissPortfolioPageData, mode: 'canvas' | 'preview'): string {
  const brand = data.brand ?? 't1'
  return `<!DOCTYPE html>
<html lang="ru" data-theme="${brand}">
<head>
<meta charset="UTF-8">
<meta name="viewport" content="width=device-width, initial-scale=1.0">
<title>BST® — Студия айдентики и типографики</title>
<link rel="stylesheet" href="https://cdn.jsdelivr.net/npm/@fontsource/archivo@5.2.5/latin-400.css">
<link rel="stylesheet" href="https://cdn.jsdelivr.net/npm/@fontsource/archivo@5.2.5/latin-500.css">
<link rel="stylesheet" href="https://cdn.jsdelivr.net/npm/@fontsource/archivo@5.2.5/latin-700.css">
<link rel="stylesheet" href="https://cdn.jsdelivr.net/npm/@fontsource/archivo@5.2.5/latin-900.css">
<link rel="stylesheet" href="https://cdn.jsdelivr.net/npm/@fontsource/ibm-plex-mono@5.2.5/latin-400.css">
<link rel="stylesheet" href="https://cdn.jsdelivr.net/npm/@fontsource/ibm-plex-mono@5.2.5/latin-500.css">
<style>${SWISS_PORTFOLIO_CSS}</style>
</head>
<body>
${SWISS_PORTFOLIO_HTML_BODY}
<script>${swissPortfolioEngineJs(brand, mode)}</script>
</body>
</html>`
}
